/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from "flickity";
require("flickity-as-nav-for");
//require("flickity-sync");
require("flickity-fade");

class Carousel {
  constructor(passedElement) {
    let self = this;

    self.elem = passedElement;
    self.primaryCarouselElem = self.elem.querySelector(
      "[data-primary-carousel]"
    );

    self.CarouselLeft = self.elem.querySelector("[data-carousel-left]");
    self.CarouselRight = self.elem.querySelector("[data-carousel-right]");

    self.dots = self.elem.querySelectorAll("[data-carousel-dot]");

    self.secondaryCarouselElem = self.elem.querySelector(
      "[data-secondary-carousel]"
    );
  }

  init() {
    let self = this;

    self.initCarousels();
  }

  initCarousels() {
    let self = this;

    self.flktyPrimary = new Flickity(self.primaryCarouselElem, {
      wrapAround: true,
      setGallerySize: true,
      pageDots: false,
      prevNextButtons: false,
      draggable: false,
      asNavFor: self.elem.querySelector("[data-secondary-carousel]"),
    });

    self.flktySecondary = new Flickity(self.secondaryCarouselElem, {
      autoPlay: 10000,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      draggable: false,
      fade: true,
      sync: self.primaryCarouselElem,
    });

    self.createListeners(self);
  }
  createListeners(self) {
    document.addEventListener("DOMContentLoaded", function () {
      self.CarouselLeft.addEventListener("click", function () {
        self.flktySecondary.previous();
      });
      self.CarouselRight.addEventListener("click", function () {
        self.flktySecondary.next();
      });
      //Dot click listener
      self.dots[0].classList.add("is-active");
      self.dots.forEach((dot, index) => {
        dot.addEventListener("click", function () {
          self.dots.forEach((dot) => {
            dot.classList.remove("is-active");
          });
          dot.classList.add("is-active");
          self.flktySecondary.select(index);
        });
      });
      //Slide change listener
      self.flktySecondary.on("change", function (index) {
        self.dots.forEach((dot) => {
          dot.classList.remove("is-active");
        });
        self.dots[index].classList.add("is-active");
      });
    });
  }
}

export default Carousel;
